import React, { useState } from 'react';

export default function AddRowModal({ isOpen, onClose, onSaveRow }) {
    const [fields, setFields] = useState({
        name: '',
        team_name: '',
        date: '',
        ext: '',
        id: '',
    });

    if (!isOpen) return null;
    
    const handleInputChange = e => {
        const { name, value } = e.target;
        setFields(prev => ({ ...prev, [name]: value }));
    };

    const handleSave = async (e) => {
        e.preventDefault();
        const success = await onSaveRow(fields);
        if (success) {
            setFields({
                name: '',
                team_name: '',
                date: '',
                ext: '',
                id: '',
            });
            onClose();
        }
        // If not successful, do not close modal
    };

    return (
        <div style={{
          position: 'fixed', top: 0, left: 0, width: '100vw', height: '100vh',
          background: 'rgba(0,0,0,0.3)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000
        }}>
          <form onSubmit={handleSave} className="modalBackground">
            <h2 style={{marginBottom: 16}}>Add Employee</h2>
            <div style={{display: 'flex', flexDirection: 'column', gap: 12}}>
              <input name="name" placeholder="Name" value={fields.name} onChange={handleInputChange} required/>
              <input name="team_name" placeholder="Team Name" value={fields.team_name} onChange={handleInputChange} required/>
              <input name="date" type="Date" placeholder="Date" value={fields.date} onChange={handleInputChange} required/>
              <input name="ext" placeholder="Ext" value={fields.ext} onChange={handleInputChange} />
            </div>
            <div style={{display: 'flex', justifyContent: 'flex-end', gap: 12, marginTop: 24}}>
              <button className='greenButton' type="submit">Save</button>
              <button className='redButton' type="button" onClick={onClose}>Cancel</button>
            </div>
          </form>
        </div>
    );
}